import SendMessageAero from "../../assets/images/SendMessageAero.svg";
import QuestImage from "../../assets/images/helphubImg.png";

import HelpHubHomeEmoji1 from "../../assets/images/HelpHubHomeEmoji1.svg";
import HelpHubHomeEmoji2 from "../../assets/images/HelpHubHomeEmoji2.svg";
import HelpHubHomeEmoji3 from "../../assets/images/HelpHubHomeEmoji3.svg";
import HelpHubHomeEmoji4 from "../../assets/images/HelpHubHomeEmoji4.svg";
import HelpHubHomeEmoji5 from "../../assets/images/HelpHubHomeEmoji5.svg";
import OpenSectionButton from "../../assets/images/OpenSectionButton.svg";
import CustomerService from "../../assets/images/CustomerService.svg";
import { HelpHubHomeTypes, QuestCriteriaWithStatusType } from "./HelpHub.type";
import { useContext, useEffect, useState } from "react";
import QuestContext from "../QuestWrapper";
import config from "../../config";
import { claimQuest } from "./Helphub.service";
import { getColorVariations, hexToGlassColor } from "./components/helperfunction";
import { extractGradientColors } from "../../general";

const HelpHubHome = (props: HelpHubHomeTypes) => {
  const {
    questsData,
    setSelectedSection,
    parentQuest,
    userId,
    token,
    styleConfig,
    contentConfig,
    taskStatus,
    onlineComponent,
    showFeedback = true,
    setShowFeedback,
    entityImage,
    uniqueUserId,
    uniqueEmailId,
    entityAuthenticationToken,
    BrandTheme,
    QuestThemeData,
    contentData,
    sectionConfig,
  } = props;

  const [allQuestsData, setAllQuestsData] = useState<
    QuestCriteriaWithStatusType[][]
  >([]);
  const { apiKey, entityId, apiType, themeConfig } = useContext(
    QuestContext.Context
  );
  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;
  // let [showFeedback, setShowFeedback] = useState<boolean>(false);
  let [feedbackLoading, setFeedbackLoading] = useState<boolean>(false);
  useEffect(() => {
    setAllQuestsData(questsData);
    let arr =
      (!!questsData?.length &&
        questsData[3]
          ?.filter((ele: QuestCriteriaWithStatusType) => ele.completed === true)
          .map((ele: QuestCriteriaWithStatusType) => ele.criteriaId)) ||
      [];
    // setTaskStatus(
    //     Math.ceil(
    //         100 *
    //             (arr?.length /
    //                 (!!questsData?.length ? questsData[3]?.length : 0))
    //     ) || 0
    // );
    if (onlineComponent) {
      if (setShowFeedback)
        setShowFeedback(
          !!questsData?.length &&
          !!questsData[0][0] &&
          questsData[0][0]?.completed == false
        );
    } else {
      if (setShowFeedback) setShowFeedback(showFeedback);
    }
  }, [questsData]);

  const submitQuest = async (answer: number) => {
    setFeedbackLoading(true);
    if (onlineComponent) {
      let claimResponse = await claimQuest(
        BACKEND_URL,
        entityId,
        parentQuest?.childCampaignActions[0].campaignId || "",
        userId || "",
        token || "",
        apiKey,
        allQuestsData[0][0]?.criteriaId,
        parentQuest?.childCampaignActions[0].campaignVariationId,
        [answer],
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );
      setFeedbackLoading(false);
      if (claimResponse?.success) {
        setShowFeedback && setShowFeedback(false);
      }
    } else {
      setShowFeedback && setShowFeedback(false);
    }
  };

  const cleanTiptapHTML = (html = "") => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll('[data-node-view-wrapper]').forEach((el) => {
      el.replaceWith(...el.childNodes);
    });

    doc.querySelectorAll('[data-drag-handle]').forEach((el) => el.remove());

    doc.querySelectorAll('[draggable]').forEach((el) =>
      el.removeAttribute('draggable')
    );

    return doc.body.innerHTML;
  };

  return (
    <div
      className={"helpHubMainInnerCont animatedDissolve"}
      style={styleConfig?.Home?.Form}
    >
      {/* upper div: div 1 */}
      <div
        className={"MainImgCont"}
        style={{
          background:
            BrandTheme?.primaryColor ||
            QuestThemeData?.accentColor ||
            styleConfig?.Home?.Banner?.background,
          ...styleConfig?.Home?.Banner,
        }}
      >
        <div className={"QuestWhiteLogoCont"}>
          {entityImage && <img src={entityImage} />}
        </div>

        <div className={"helpHubTextCont"}>
          <div
            className={"helpHubHelloHead"}
            style={{
              fontFamily: BrandTheme?.fontFamily || themeConfig?.fontFamily,
              color: "white",
              ...styleConfig?.Home?.BannerText,
            }}
          >
            Hello there 👋🏻
          </div>
          <div
            className={"helpHubHelpHead"}
            style={{
              fontFamily: BrandTheme?.fontFamily || themeConfig?.fontFamily,
              color: "white",
              ...styleConfig?.Home?.BannerText,
            }}
          >
            How can we help?
          </div>
          {/* <div className={"helpHubImage"}>
            <img src={Modal3} />
          </div> */}
        </div>
      </div>

      {/* lower div : div 2 */}
      <div style={{ width: "100%" }} className="q-helphub-InnerCont">
        {sectionConfig?.Chat && <div
          className={"SendMessageCont"}
          style={{
            background: themeConfig?.backgroundColor,
            ...styleConfig?.Home?.Card,
            borderColor: themeConfig?.borderColor,
            borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius
          }}
        >
          {/* <div className={"HelloText"} style={styleConfig?.Home?.BannerText}>
            {contentConfig?.heading || "Hello there"}
          </div>
          {!contentConfig?.heading && (
            <div className={"HelloText"} style={styleConfig?.Home?.BannerText}>
              How can we help?
            </div>
          )} */}
          <div className="CustomerServiceCont">
            <div
              className={"CustomerServiceInnerCont"}
              style={{
                background: hexToGlassColor(BrandTheme?.primaryColor || QuestThemeData?.accentColor)

              }}
            >
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    opacity="0.4"
                    d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
                    fill={
                      BrandTheme?.primaryColor || (QuestThemeData?.accentColor?.includes("gradient")
                        ? extractGradientColors(QuestThemeData?.accentColor)
                        : QuestThemeData?.accentColor) || "#9035FF"
                    }
                  />
                  <path
                    d="M22.0003 12.8603C22.0003 15.1503 20.8203 17.1803 19.0003 18.4603L17.6603 21.4103C17.3503 22.0803 16.4503 22.2103 15.9803 21.6403L14.5003 19.8603C12.0803 19.8603 9.92031 18.7903 8.57031 17.1203L9.50031 16.0003C13.6403 16.0003 17.0003 12.8703 17.0003 9.00031C17.0003 7.95031 16.7503 6.96031 16.3003 6.07031C19.5703 6.82031 22.0003 9.58029 22.0003 12.8603Z"
                    fill={
                      BrandTheme?.primaryColor || (QuestThemeData?.accentColor?.includes("gradient")
                        ? extractGradientColors(QuestThemeData?.accentColor)
                        : QuestThemeData?.accentColor) || "#9035FF"
                    }
                  />
                  <path
                    d="M12 9.75H7C6.59 9.75 6.25 9.41 6.25 9C6.25 8.59 6.59 8.25 7 8.25H12C12.41 8.25 12.75 8.59 12.75 9C12.75 9.41 12.41 9.75 12 9.75Z"
                    fill={
                      BrandTheme?.primaryColor || (QuestThemeData?.accentColor?.includes("gradient")
                        ? extractGradientColors(QuestThemeData?.accentColor)
                        : QuestThemeData?.accentColor) || "#9035FF"
                    }
                  />
                </svg>
              </div>
              <p
                style={{
                  fontFamily: themeConfig?.fontFamily,
                  color: BrandTheme?.primaryColor || (QuestThemeData?.accentColor?.includes("gradient")
                    ? extractGradientColors(QuestThemeData?.accentColor)
                    : QuestThemeData?.accentColor) || "#9035FF"
                }}
              >
                Customer Service
              </p>
            </div>
          </div>

          <div className={"CustomerServiceSendMessageTextCont"}>
            <p
              className={"CustomerServiceHead"}
              style={{
                color: BrandTheme?.titleColor || themeConfig?.primaryColor,
                fontFamily: BrandTheme?.fontFamily || themeConfig?.fontFamily,
                ...styleConfig?.Home?.Heading,
              }}
            >
              {contentConfig?.chatButton?.heading || "Send us a message"}
            </p>
            <p
              className={"CustomerServiceDesc"}
              style={{
                color:
                  BrandTheme?.contentColor || themeConfig?.secondaryColor,
                ...styleConfig?.Home?.SubHeading,
                fontFamily: BrandTheme?.fontFamily || themeConfig?.fontFamily,
              }}
            >
              {contentConfig?.chatButton?.subHeading ||
                "Let us help with all your questions"}
            </p>
          </div>

          <div className={"SendMessageButtonCont"}>
            {/* <div className={"SendMessageButtonImagesCont"}>
              <img src={Man1} alt="" />
              <img
                src={Woman1}
                alt=""
                style={{
                  marginLeft: "-14px",
                }}
              />
              <img
                src={Man2}
                alt=""
                style={{
                  marginLeft: "-14px",
                }}
              />
              <img
                src={Woman2}
                alt=""
                style={{
                  marginLeft: "-14px",
                }}
              />
            </div> */}

            <div
              className={"SendMessageButton"}
              onClick={() => setSelectedSection("Chat")}
              style={{
                background:
                  styleConfig?.Home?.Button?.background ||
                  BrandTheme?.primaryColor ||
                  QuestThemeData?.buttonColor ||
                  QuestThemeData?.accentColor ||
                  themeConfig?.buttonColor,
              }}
            >
              <p
                style={{
                  fontFamily: BrandTheme?.fontFamily || themeConfig?.fontFamily,
                  color: styleConfig?.Home?.Button?.color,
                }}
              >
                Message Now
              </p>
              <img src={SendMessageAero} alt="" />
            </div>
          </div>
        </div>}

        {/* community */}
        <div
          className="q-helphub-quest-community-cont"
          style={{
            background: themeConfig?.backgroundColor,
            ...styleConfig?.Home?.Card,
            borderColor: themeConfig?.borderColor,
            borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius
          }}
          onClick={() => {
            (contentConfig?.box1?.link || contentData?.Home?.link) &&
              window.open((contentConfig?.box1?.link || contentData?.Home?.link), "_blank");
          }}
        >
          <div className="q-helphub-quest-community-imageCont">
            <div
              className="q-helphub-quest-community-quest-image"
              style={{ background: BrandTheme?.primaryColor || QuestThemeData?.accentColor }}
            >
              <img src={contentConfig?.box1?.image || contentData?.Home?.image || QuestImage} />
            </div>
          </div>

          <div className="q-helphub-quest-community-descCont">
            <div
              className="q-helphub-quest-community-desc"
              style={{
                color: BrandTheme?.titleColor || themeConfig?.primaryColor,
                ...styleConfig?.Home?.Heading,
              }}
            >
              <p
                style={{
                  color: BrandTheme?.titleColor || themeConfig?.primaryColor,
                  ...styleConfig?.Home?.Heading,
                }}
              >
                {contentConfig?.box1?.heading || contentData?.Home?.title || "The Questlabs community"}
              </p>
              <img src={OpenSectionButton} alt="" />
            </div>

            <div
              className="q-helphub-quest-community-full-desc"
              style={{
                color:
                  BrandTheme?.contentColor || themeConfig?.secondaryColor,
                ...styleConfig?.Home?.SubHeading,
              }}
            >
              {contentConfig?.box1?.subHeading || contentData?.Home?.description ||
                "Be sure to check out the Quest labs community for support, plus tips & tricks from Quest users and much more coming soon"}
            </div>
          </div>
        </div>

        {/* search for help  */}
        {sectionConfig?.FAQs && <div
          className="q-helhub-search-community"
          style={{
            background: themeConfig?.backgroundColor,
            ...styleConfig?.Home?.Card,
            borderColor: themeConfig?.borderColor,
            borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius
          }}
        >
          <div
            className="search-input"
            onClick={() => setSelectedSection("Help")}
          >
            <div className="q-helphub-search-input-cont">
              <input
                className="q-helphub-search-input"
                placeholder="Search for help..."
              />
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_4762_1863)">
                    <circle
                      cx="7.66671"
                      cy="7.66659"
                      r="6.33333"
                      stroke="#B9B9B9"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M13.3334 13.3333L14.6667 14.6666"
                      stroke="#B9B9B9"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4762_1863">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>

          <div className="q-helphub-search-messege">
            {!!allQuestsData?.length &&
              allQuestsData[1]?.map(
                (value: QuestCriteriaWithStatusType, index: number) => (
                  <div
                    className="q-helphub-search-messege-cont"
                    key={index}
                    onClick={() => setSelectedSection("Help")}
                    style={{
                      borderBottom:
                        allQuestsData[1]?.length - 1 == index
                          ? "none"
                          : "1px solid var(--Neutral-White-300, #efefef)",
                    }}
                  >
                    <div
                      className="q-helphub-search-messege-title"
                      style={{
                        color:
                          BrandTheme?.secondaryColor ||
                          themeConfig?.secondaryColor,
                        ...styleConfig?.Home?.SubHeading,
                      }}
                    >
                      {value?.question}
                    </div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.67461 2.95363C5.88428 2.77392 6.19993 2.7982 6.37964 3.00787L10.3796 7.67453C10.5401 7.86178 10.5401 8.13808 10.3796 8.32532L6.37964 12.992C6.19993 13.2017 5.88428 13.2259 5.67461 13.0462C5.46495 12.8665 5.44067 12.5509 5.62038 12.3412L9.34147 7.99993L5.62038 3.65866C5.44067 3.44899 5.46495 3.13334 5.67461 2.95363Z"
                          fill="#B9B9B9"
                        />
                      </svg>
                    </div>
                  </div>
                )
              )}
          </div>
        </div>}

        {/* get  updates */}
        {sectionConfig?.Updates && <div className="q-helphub-update-mainCont">
          <div
            className="q-helphub-search-updates"
            style={{
              background: themeConfig?.backgroundColor,
              ...styleConfig?.Home?.Card,
              borderColor: themeConfig?.borderColor,
              borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius
            }}
          >
            <div
              className="q-helphub-updates-innercont"
              onClick={() => setSelectedSection("Updates")}
            >
              <div
                className="q-helphub-quest-community-desc"
                style={{
                  color: BrandTheme?.primaryColor || themeConfig?.primaryColor,
                  ...styleConfig?.Home?.Heading,
                  fontSize: "18px",
                }}
              >
                <p
                  style={{
                    color:
                      BrandTheme?.titleColor || themeConfig?.primaryColor,
                  }}
                >
                  Get Updates
                </p>
              </div>
              <div className="q-helphub-updates-desc">
                {!!allQuestsData?.length &&
                  allQuestsData[2]?.map(
                    (value: QuestCriteriaWithStatusType, index: number) =>
                      index < 2 && (
                        <div
                          className={`q-helphub-updates-innerCont${index + 1}`}
                          key={index}
                        >
                          <div
                            style={{
                              color:
                                BrandTheme?.titleColor ||
                                themeConfig?.primaryColor,
                              ...styleConfig?.Home?.Heading,
                            }}
                          >
                            {value?.linkTitle}
                          </div>
                          <div
                            style={{
                              color:
                                BrandTheme?.contentColor ||
                                themeConfig?.secondaryColor,
                              ...styleConfig?.Home?.SubHeading,
                            }}
                            dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.description) }}
                          />
                        </div>
                      )
                  )}
              </div>
            </div>
            <button
              className="q-helphub-updates-button"
              onClick={() => setSelectedSection("Updates")}
              style={{
                background:
                  BrandTheme?.primaryColor ||
                  QuestThemeData?.buttonColor ||
                  QuestThemeData?.accentColor ||
                  themeConfig?.buttonColor,
                fontFamily: BrandTheme?.fontFamily || themeConfig?.fontFamily,
                ...styleConfig?.Home?.Button,
              }}
            >
              See all updates
            </button>
          </div>
        </div>}

        {/* complete profile */}
        {sectionConfig?.Tasks && <div
          className="q-helphub-compProfile"
          style={{
            background: themeConfig?.backgroundColor,
            ...styleConfig?.Home?.Card,
            borderColor: themeConfig?.borderColor,
            borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius
          }}
          onClick={() => setSelectedSection("Tasks")}
        >
          {/* one */}
          <div className="q-helphub-compProfile-heading-cont">
            <div
              className="q-helphub-compProfile-heading-text"
              style={{
                color: BrandTheme?.titleColor || themeConfig?.primaryColor,
                ...styleConfig?.Home?.Heading,
              }}
            >
              {contentConfig?.box4?.heading || "Complete your profile"}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.67461 2.95363C5.88428 2.77392 6.19993 2.7982 6.37964 3.00787L10.3796 7.67453C10.5401 7.86178 10.5401 8.13808 10.3796 8.32532L6.37964 12.992C6.19993 13.2017 5.88428 13.2259 5.67461 13.0462C5.46495 12.8665 5.44067 12.5509 5.62038 12.3412L9.34147 7.99993L5.62038 3.65866C5.44067 3.44899 5.46495 3.13334 5.67461 2.95363Z"
                fill="#B9B9B9"
              />
            </svg>
          </div>

          {/* two  */}
          <div className="q-helphub-compProfile-progress-con">
            {/* progress percentage */}
            <div
              className="q-helphub-compProfile-progress-per"
              style={{
                color: BrandTheme?.primaryColor || (QuestThemeData?.accentColor?.includes("gradient") ? extractGradientColors(
                  QuestThemeData?.accentColor
                ) : QuestThemeData?.accentColor) || BrandTheme?.tertiaryColor,
              }}
            >
              {taskStatus || 0}% Completed
            </div>
            <div className="q-helphub-compProfile-progress-bar-con">
              {/* progress bar */}
              <div
                className="q-helphub-compProfile-progress-bar"
                style={{
                  width: `${taskStatus || 0}%`,
                  background:
                    BrandTheme?.primaryColor || QuestThemeData?.accentColor || BrandTheme?.secondaryColor,
                }}
              ></div>
            </div>
          </div>

          <div
            className="q-helphub-compProfile-para-text"
            style={{
              color: BrandTheme?.secondaryColor || themeConfig?.secondaryColor,
              ...styleConfig?.Home?.SubHeading,
            }}
          >
            {contentConfig?.box4?.subHeading || contentData?.Home?.completeDescription ||
              "Be sure to check out the Quest labs community for support, plus tips & tricks from Quest users"}
          </div>
        </div>}

        {/* review  */}
        <div
          className={`q-helphub-review ${showFeedback && "q-show-feedback"}`}
          style={{
            background: themeConfig?.backgroundColor,
            ...styleConfig?.Home?.Card,
            borderColor: themeConfig?.borderColor,
            borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius
          }}
        >
          <div className="q-helphub-review-text-emoji-cont">
            <div className="q-helphub-review-text-con">
              <div
                className="q-helphub-review-text-head"
                style={{
                  color: BrandTheme?.titleColor || themeConfig?.primaryColor,
                  ...styleConfig?.Home?.Heading,
                }}
              >
                {contentConfig?.box5?.heading || "How satisfied are you?"}
              </div>

              <div
                className="q-helphub-review-text-para"
                style={{
                  color:
                    BrandTheme?.contentColor || themeConfig?.secondaryColor,
                  ...styleConfig?.Home?.SubHeading,
                }}
              >
                {contentConfig?.box5?.subHeading ||
                  "How would you rate this journey after using the product after so long?"}
              </div>
            </div>

            <div className="q-helphub-review-emoji-caption-con">
              <div className="q-helphub-review-emoji-cont">
                {[
                  HelpHubHomeEmoji1,
                  HelpHubHomeEmoji2,
                  HelpHubHomeEmoji3,
                  HelpHubHomeEmoji4,
                  HelpHubHomeEmoji5,
                ].map((e, i) => (
                  <img
                    src={e}
                    alt=""
                    key={i}
                    onClick={() => submitQuest(i + 1)}
                  />
                ))}
              </div>
              <div className="q-helphub-review-emoji-caption">
                <div
                  style={{
                    color:
                      BrandTheme?.secondaryColor || themeConfig?.secondaryColor,
                    ...styleConfig?.Home?.SubHeading,
                  }}
                >
                  Not satisfied
                </div>
                <div
                  style={{
                    color:
                      BrandTheme?.secondaryColor || themeConfig?.secondaryColor,
                    ...styleConfig?.Home?.SubHeading,
                  }}
                >
                  Very satisfied
                </div>
              </div>
            </div>
          </div>
          {feedbackLoading && (
            <div className="q-helphub-review-loader-con">
              <div className="q-helphub-review-loader"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpHubHome;
